import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";

import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardIcon from "../../components/Card/CardIcon.jsx";
import CardBody from "../../components/Card/CardBody.jsx";

import { cardTitle } from "../../assets/jss/material-dashboard-pro-react.jsx";
import Assignment from "@material-ui/icons/Assignment";

import { Link } from 'react-router-dom'
import Button from "../../components/CustomButtons/Button.jsx";

const style = {
	customCardContentClass: {
		paddingLeft: "0",
		paddingRight: "0"
	},
	cardIconTitle: {
		...cardTitle,
		marginTop: "15px",
		marginBottom: "0px"
	}
};

class ThankYouPage extends React.Component {

	render() {
		const { classes } = this.props;
		return (
			<div>
				<GridContainer>
					<GridItem xs={3}>
					</GridItem>
					<GridItem xs={6}>
					<Card>
						<CardHeader color="warning" icon>
							<CardIcon color="warning">
								<Assignment />
							</CardIcon>
							<h4 className={classes.cardIconTitle}>Thank you</h4>
						</CardHeader>
						<CardBody>
						<p>
							Thank you for your request. You can download your configuration
							in a PDF file via the download button.
						</p>
						<p>
							We will contact you shortly.
						</p>
						<p>
							For further questions please contact us by phone: +49 (0) 371 40043-222.
						</p>
						<p>
							Best regards,<br/>
							The team of 3D-Micromac AG
						</p>
						<p>
							<a href={this.props.location.state.pdfUrl} target="_blank">
								<Button color="warning">PDF Download</Button>
							</a>
						</p>
						</CardBody>
					</Card>
					</GridItem>
					<GridItem xs={3}>
					</GridItem>
				</GridContainer>
			</div>
		);
	}
}

export default withStyles(style)(ThankYouPage);



// WEBPACK FOOTER //
// ./src/views/PagesEN/ThankYou.jsx